import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import DataTable from "@/components/Tables/DataTable"
import { useEffect, useState } from "react"

export default function StockTransactionList() {
  return (
    <>
      <CrudProvider>
        <StockTransactionTable />
      </CrudProvider>
    </>
  )
}

function StockTransactionTable() {
  return (
    <>
      <CustomTable
        columns={columns}
        apiPath="stock-transactions"
        action={false}
        addBtn={false}
        label="Stock Transactions"
        onExport={true}
      />
    </>
  )
}
